// Fábrica de rota lazy compartilhada pelas rotas do aluno (rotas.tsx) e do painel (rotas.painel.tsx).
import type { ComponentType } from "react";
import type { RouteObject } from "react-router";
import { ErroRota } from "./ErroRota";

type ModuloTela = { default: ComponentType };
/**
 * Tela lazy com tela de erro própria (QA D-02). O `errorElement` fica em cada rota: o erro aparece
 * dentro do layout pai (tab bar/menu continuam), e falha de chunk após deploy recarrega a página.
 */
export const tela = (carregar: () => Promise<ModuloTela>): Pick<RouteObject, "lazy" | "errorElement"> => ({
  lazy: async () => {
    try {
      return { Component: (await carregar()).default };
    } catch (erro) {
      // Se o `lazy` rejeitar na carga inicial, a rota continua "lazy" e o React Router não renderiza nada
      // (tela em branco). Resolvemos com um componente que relança o erro: o errorElement mostra a tela.
      return {
        Component: () => {
          throw erro;
        },
      };
    }
  },
  errorElement: <ErroRota />,
});
